import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const StyledComp = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 380px) 1fr;
  gap: 64px;
  align-items: start;
  max-width: 1400px;
  margin: 0 auto;
  padding: 96px 24px;
  &.full{
      // max-width: 100vw;
      padding: 96px 48px;
  }
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 48px;
    padding: 24px;
  }
  /* ---------- intro column ---------- */
  .intro h2 {
    margin: 0 0 24px;
    font-size: 40px;
    line-height: 1.15;
    color: var(--black);
  }
  .intro p {
    margin: 0;
    font-size: 12px;
    line-height: 1.6;
    color: var(--grey);
  }
  .intro p + p {
    margin-top: 2px;
  }
  .cta {
    margin-top: 32px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    background-color: var(--black);
    color: var(--white);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    transition-duration: 0.3s;
  }
  .cta:hover {
    background-color: #333;
  }
  .cta svg {
    padding-left: 10px;
    transition-duration: 0.3s;
  }
  .cta:hover svg {
    transform: translateX(2px);
  }
  /* ---------- tile grid ---------- */
  .grid {
    display: flex;
    flex-wrap: wrap;
    gap: 44px 28px;
    /* prevents this flex item's own size from growing past its 1fr
       allotment when tile content below has a large intrinsic size */
    min-width: 0;
  }
  .tile {
    min-width: 301px;
    max-width: 750px;
    flex: 1 1 300px;
  }
  .tile-photo {
    position: relative;
    width: 100%;
    max-width: 100%;
    aspect-ratio: 4 / 3.4;
    border-radius: 16px;
    overflow: hidden;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    > div, > section{
      width: 100%;
      min-width: 100%;
    }
    &.scaled{
      > div, > section{
        transform: scale(0.75);

      }

      @media (max-width: 500px) {
        > div, > section{
          transform: scale(0.6);
        }
      }

    }
    &.corner{
      > div, > section{
        width: 120%;
        height: 120%;
        min-width: 120%;
        min-height: 120%;
        margin-top: 100px;
        margin-left: 100px;
      }
    }
    &.overthetop{
      > div, > section{
        margin-top: -150px;
      }
    }
  }
  .tile-caption {
    margin-top: 18px;
  }
  .tile-caption h3 {
    margin: 0 0 6px;
    font-size: 17px;
    font-weight: 600;
    color: var(--black);
  }
  .tile-caption p {
    margin: 0;
    font-size: 15px;
    line-height: 1.5;
    color: var(--grey);
  }
`;
const Comp = ({
  full=false,
  title='',
  subtitle='',
  cta='',
  ctaLink='/',
  tiles=[ ]
}) => {
  return (
    <StyledComp className={full ? 'full' : ''}>
      <div className="intro">
        <h2 className="serif">
          {title}
        </h2>
        <p>
          {subtitle}
        </p>
        <Link to={ctaLink} className="cta">
          {cta}
        </Link>
      </div>
      <div className="grid">
        {tiles.map((t, i) => {
          return (
            <div className="tile" key={i}>
              <div className={`tile-photo ${t.cn}`} style={{
                backgroundImage: `url('/product_images/${t.img}')`
              }}>
                {t.tile}
              </div>
              <div className="tile-caption">
                <h3>{t.title}</h3>
                <p>{t.caption}</p>
              </div>
            </div>
          )
        })}
      </div>
    </StyledComp>
  );
};
export default Comp;
